/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminV1OrganizationsPaymentsInvoicesListParams,
  AdminV1OrganizationsPaymentsInvoicesUpdate200,
  CreateInvoices,
  Invoice,
  InvoiceCreated,
  PaginatedInvoiceListList,
  UpdateInvoice
} from '.././model';

import adminV1OrganizationsPaymentsInvoicesListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsInvoicesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsInvoicesRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsInvoicesUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsInvoicesPayWithCashCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsInvoicesRefundCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsInvoicesResendEmailCreateMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsInvoicesList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsInvoicesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsInvoicesListMutator<PaginatedInvoiceListList>>,) => {
      return adminV1OrganizationsPaymentsInvoicesListMutator<PaginatedInvoiceListList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/invoices/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsInvoicesCreate = (
    organizationId: number,
    createInvoices: CreateInvoices,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsInvoicesCreateMutator<InvoiceCreated>>,) => {
      return adminV1OrganizationsPaymentsInvoicesCreateMutator<InvoiceCreated>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/invoices/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInvoices
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsInvoicesRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsInvoicesRetrieveMutator<Invoice>>,) => {
      return adminV1OrganizationsPaymentsInvoicesRetrieveMutator<Invoice>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/invoices/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsInvoicesUpdate = (
    organizationId: number,
    id: number,
    updateInvoice: UpdateInvoice,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsInvoicesUpdateMutator<AdminV1OrganizationsPaymentsInvoicesUpdate200>>,) => {
      return adminV1OrganizationsPaymentsInvoicesUpdateMutator<AdminV1OrganizationsPaymentsInvoicesUpdate200>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/invoices/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateInvoice
    },
      options);
    }
  /**
 * Process a one-time cash payment for an invoice using the payabli_invoice_id.
 * @summary Process a one-time cash payment for an invoice using the payabli_invoice_id.
 */
export const adminV1OrganizationsPaymentsInvoicesPayWithCashCreate = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsInvoicesPayWithCashCreateMutator<void>>,) => {
      return adminV1OrganizationsPaymentsInvoicesPayWithCashCreateMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/invoices/${id}/pay_with_cash/`, method: 'POST'
    },
      options);
    }
  /**
 * Refund an invoice and all associated payments
 * @summary Refund an invoice and all associated payments
 */
export const adminV1OrganizationsPaymentsInvoicesRefundCreate = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsInvoicesRefundCreateMutator<void>>,) => {
      return adminV1OrganizationsPaymentsInvoicesRefundCreateMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/invoices/${id}/refund/`, method: 'POST'
    },
      options);
    }
  /**
 * Resend the invoice email to the recipient
 * @summary Resend the invoice email to the recipient
 */
export const adminV1OrganizationsPaymentsInvoicesResendEmailCreate = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsInvoicesResendEmailCreateMutator<void>>,) => {
      return adminV1OrganizationsPaymentsInvoicesResendEmailCreateMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/invoices/${id}/resend_email/`, method: 'POST'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsInvoicesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsInvoicesList>>>
export type AdminV1OrganizationsPaymentsInvoicesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsInvoicesCreate>>>
export type AdminV1OrganizationsPaymentsInvoicesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsInvoicesRetrieve>>>
export type AdminV1OrganizationsPaymentsInvoicesUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsInvoicesUpdate>>>
export type AdminV1OrganizationsPaymentsInvoicesPayWithCashCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsInvoicesPayWithCashCreate>>>
export type AdminV1OrganizationsPaymentsInvoicesRefundCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsInvoicesRefundCreate>>>
export type AdminV1OrganizationsPaymentsInvoicesResendEmailCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsInvoicesResendEmailCreate>>>
